export interface Kpi {
  label: string;
  value: string;
  change: string;
  direction: "up" | "down" | "none";
  icon: string;
}

export const kpis: Kpi[] = [
  { label: "طلبات اليوم", value: "24", change: "↑ 12% عن أمس", direction: "up", icon: "ri-clipboard-line" },
  { label: "إيرادات اليوم", value: "1,240 ر.س", change: "↑ 8%", direction: "up", icon: "ri-wallet-3-line" },
  { label: "التقييم العام", value: "4.8 ★", change: "", direction: "none", icon: "ri-star-line" },
  { label: "نسبة القبول", value: "92%", change: "↓ 3% عن الأسبوع", direction: "down", icon: "ri-check-double-line" },
];

export type RecentOrderStatus = "جديد" | "قيد التنفيذ" | "مكتمل" | "ملغي";

export interface RecentOrder {
  id: string;
  customer: string;
  service: string;
  status: RecentOrderStatus;
  amount: string;
}

export const recentOrders: RecentOrder[] = [
  { id: "GH-2847", customer: "أحمد محمد", service: "غسل خارجي وداخلي", status: "جديد", amount: "70" },
  { id: "GH-2849", customer: "سارة العتيبي", service: "مغاسل — 4 قطع", status: "قيد التنفيذ", amount: "83" },
  { id: "GH-2850", customer: "خالد الحربي", service: "تنظيف شامل", status: "مكتمل", amount: "385" },
  { id: "GH-2851", customer: "نورة الشهري", service: "غسل خارجي", status: "مكتمل", amount: "35" },
  { id: "GH-2852", customer: "عمر القحطاني", service: "تلميع كامل", status: "ملغي", amount: "120" },
];

export interface Distribution {
  label: string;
  pct: number;
  color: string;
}

export const orderDistribution: Distribution[] = [
  { label: "غسيل سيارات", pct: 45, color: "#00AAB7" },
  { label: "تنظيف منازل", pct: 30, color: "#00C4CF" },
  { label: "مغاسل ملابس", pct: 25, color: "#33D1DA" },
];

export interface RevenuePoint {
  label: string;
  amount: number;
}

export const revenue7: RevenuePoint[] = [
  { label: "11 أغسطس", amount: 980 },
  { label: "12 أغسطس", amount: 1240 },
  { label: "13 أغسطس", amount: 1100 },
  { label: "14 أغسطس", amount: 1450 },
  { label: "15 أغسطس", amount: 890 },
  { label: "16 أغسطس", amount: 1320 },
  { label: "17 أغسطس", amount: 1560 },
];

export const revenue30: RevenuePoint[] = [
  { label: "19 يوليو", amount: 3200 },
  { label: "22 يوليو", amount: 2800 },
  { label: "25 يوليو", amount: 3600 },
  { label: "28 يوليو", amount: 3100 },
  { label: "31 يوليو", amount: 4200 },
  { label: "3 أغسطس", amount: 3800 },
  { label: "6 أغسطس", amount: 4500 },
  { label: "9 أغسطس", amount: 4000 },
  { label: "12 أغسطس", amount: 4800 },
  { label: "15 أغسطس", amount: 5100 },
];

export const revenue90: RevenuePoint[] = [
  { label: "يونيو", amount: 11200 },
  { label: "نصف يوليو", amount: 9800 },
  { label: "أواخر يوليو", amount: 12400 },
  { label: "نصف أغسطس", amount: 13600 },
  { label: "أواخر أغسطس", amount: 14800 },
  { label: "سبتمبر", amount: 16200 },
];